import { clsx } from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';
import type { CorStatus } from '../tokens/tokens';

export interface PilulaProps extends HTMLAttributes<HTMLSpanElement> {
  cor?: CorStatus | 'acento' | 'neutra' | 'aviso' | 'erro' | 'ok';
  icone?: ReactNode;
}

export function Pilula({ cor = 'neutra', icone, className, children, ...resto }: PilulaProps) {
  return (
    <span className={clsx('pilula', className)} data-cor={cor} {...resto}>
      {icone}
      {children}
    </span>
  );
}

/** Bolinha de legenda: nunca só cor — role="img" com o rótulo (07 §1.4). */
export function BolinhaStatus({ cor, rotulo }: { cor: CorStatus; rotulo: string }) {
  return <span className="bolinha" role="img" aria-label={`Status: ${rotulo}`} title={rotulo} style={{ ['--_cor' as string]: `var(--st-${cor})` }} />;
}

/** Situação em etiqueta (lista, painel de detalhes): bolinha + texto na cor da legenda, nunca só cor. */
export function EtiquetaStatus({ cor, rotulo }: { cor: CorStatus; rotulo: string }) {
  return (
    <span className="etiqueta-status" data-cor={cor} style={{ ['--_cor' as string]: `var(--st-${cor})` }}>
      <span className="etiqueta-status-ponto" aria-hidden="true" />
      {rotulo}
    </span>
  );
}

export function Legenda({ itens, aoFiltrar }: { itens: { cor: CorStatus; rotulo: string }[]; aoFiltrar?: (cor: CorStatus) => void }) {
  return (
    <ul className="legenda" aria-label="Legenda">
      {itens.map((i) => (
        <li key={i.cor + i.rotulo}>
          <button type="button" className="botao botao-fantasma" data-tamanho="p" onClick={() => aoFiltrar?.(i.cor)} disabled={!aoFiltrar}>
            <BolinhaStatus cor={i.cor} rotulo={i.rotulo} />
            {i.rotulo}
          </button>
        </li>
      ))}
    </ul>
  );
}
